export default {
  $vuetify: {
    badge: 'Placa',
    close: 'Cerrar',
    dataIterator: {
      noResultsText: 'Ningún elemento coincide con la búsqueda',
      loadingText: 'Cargando...',
    },
    dataTable: {
      itemsPerPageText: 'Filas por página:',
      ariaLabel: {
        sortDescending: 'Orden descendente.',
        sortAscending: 'Orden ascendente.',
        sortNone: 'Sin ordenar.',
        activateNone: 'Pulse para quitar orden.',
        activateDescending: 'Pulse para ordenar descendente.',
        activateAscending: 'Pulse para ordenar ascendente.',
      },
      sortBy: 'Ordenado por',
    },
    dataFooter: {
      itemsPerPageText: 'Elementos por página:',
      itemsPerPageAll: 'Todos',
      nextPage: 'Página siguiente',
      prevPage: 'Página anterior',
      firstPage: 'Primer página',
      lastPage: 'Última página',
      pageText: '{0}-{1} de {2}',
    },
    datePicker: {
      itemsSelected: '{0} seleccionados',
      nextMonthAriaLabel: 'Próximo mes',
      nextYearAriaLabel: 'Próximo año',
      prevMonthAriaLabel: 'Mes anterior',
      prevYearAriaLabel: 'Año anterior',
    },
    noDataText: 'No hay datos disponibles',
    carousel: {
      prev: 'Visual anterior',
      next: 'Visual siguiente',
      ariaLabel: {
        delimiter: 'Carousel slide {0} of {1}',
      },
    },
    calendar: {
      moreEvents: '{0} más',
    },
    fileInput: {
      counter: '{0} archivos',
      counterSize: '{0} archivos ({1} en total)',
    },
    timePicker: {
      am: 'AM',
      pm: 'PM',
    },
    pagination: {
      ariaLabel: {
        wrapper: 'Navegación de paginación',
        next: 'Página siguiente',
        previous: 'Página anterior',
        page: 'Ir a la página {0}',
        currentPage: 'Página actual, página {0}',
      },
    },
    rating: {
      ariaLabel: {
        icon: 'Rating {0} of {1}',
      },
    },
  },
  errors: {
    login: {
      401: "Credenciales no válidas",
      403: "Credenciales no válidas",
      500: "Se ha producido un error, intenta iniciar sesión de nuevo más tarde.",
      503: "Actualmente cargando una actualización, intente iniciar sesión nuevamente más tarde.",
    }
  },
  navigation: {
    selectAll: "Seleccionar todos",
    route: {
      forms: "Formularios",
      users: "Sesiones",
      tenants: "Instituciones",
      repliesLog: "Registro Respuestas"
    }
  },
  login: {
    actions: {
      forgotPassword: "¿Olvidaste tu contraseña?",
      login: "Ingresar",
      backToLogin: "Volver al Login",
      recoverPassword: "Recuperar Contraseña"
    },
    form: {
      fields: {
        username: "Email",
        password: "Contraseña",
        email: "Email"
      },
      validations: {
        username: {
          required: "Debe ingresar el nombre de usuario"
        },
        password: {
          required: "Debe ingresar la contraseña"
        }
      }
    }
  },
  users: {
    title: "Sesiones",
    actions: {
      add: "Agregar"
    },
    headers: {
      id: "Id",
      email: "Correo",
      name: "Nombre",
      tenant: "Organización",
      title: "Cargo",
      lastLogin: "Último login",
      role: "Rol",
      actions: "Acciones"
    },
    form: {
      add: "Nuevo Usuario",
      roleChange: "Cambiar Rol",
      fields: {
        givenName: "Nombre",
        familyName: "Apellido",
        email: "Email",
        username: "Usuario",
        tenant: "Institución",
        role: "Rol",
      },
      actions: {
        save: "Guardar",
        cancel: "Cancelar"
      },
      roles: {
        admin: "Administrador",
        maintainer: "Mantenedor",
        user: "Usuario Normal"
      }
    }
  },
  tenants: {
    title: "Instituciones",
    actions: {
      add: "Agregar"
    },
    headers: {
      id: "Id",
      name: "Nombre",
      description: "Descripción",
      contact_person: "Nombre Contacto",
      actions: "Acciones"
    },
    form: {
      add: "Nueva Institución",
      fields: {
        name: "Nombre",
        description: "Descripción",
        contactPerson: "Nombre Contacto",
      },
      actions: {
        save: "Guardar",
        cancel: "Cancelar"
      }
    }
  },
  replyLogs: {
    title: "Respuestas",
    actions: {
      create: "Creación",
      edit: "Edición",
      title: {
        edit: "Preguntas editadas",
        create: "Preguntas contestadas"
      }
    },
    headers: {
      formName: "Formulario",
      id: "ID",
      userName: "Usuario",
      tenantName: "Organización",
      createdAt: "Fecha",
      action: "Acción"
    }
  },
  forms: {
    title: "Formularios",
    noDataMessage: "No existen formularios disponibles",
    submitted: "Su respuesta ha sido registrada.",
    closedEdit: "La respuesta no ha sido editada, puedes hacer una nueva respuesta con el siguiente botón",
    copyLink: "Enlace copiado al portapapeles.",
    delete: {
      title: "Eliminar formulario",
      message: "Esta seguro que desea elimnar el formulario",
      action: "Eliminar"
    },
    actions: {
      add: "Agregar",
      organizations: "Organizaciones",
      otherResponse: "Otra respuesta",
      edit: "Editar",
      delete: "Eliminar",
      submit: "Enviar nueva respuesta",
      replies: "Respuestas",
      downloadExcel: "Descargar Respuestas",
      shareLink: "Compartir enlace para responder formulario",
      shareLinkShort: "Compartir enlace",
      downloadJson: "Descargar Json",
      goToHome: "Volver al inicio",
    },
    tabs: {
      formSettings: "Ajustes",
      newForm: "Creación Formulario",
      preview: "Vista Previa"
    },
    headers: {
      answers: "Respuestas",
      lastUpdate: "Última modificación",
    },
    defaultData: {
      id: {
        text: "ID"
      },
      name: {
        text: "Nombre"
      }
    },
    replies: {
      title: "Respuestas",
      headers: {
        id: "ID",
        createdAt: "Fecha Creación",
        updatedAt: "Fecha Actualización",
        createdBy: "Creado Por",
        actions: "Acciones",
      }
    },
    downloadExcel: {
      title: "Selecciona la organización de donde se obtendrá la data",
      confirmTitle: "¿Estás seguro de descargar los datos de este tenant?",
      tenants: "Organizaciones",
      selectAll: "Elegir Todas",
      actions: {
        download: "Descargar Excel"
      }
    },
    form: {
      add: "Nuevo Formulario",
      groups: "Selección de Grupos",
      sendToJoin: "Guardar y Enviar a Join",
      next: "Continuar",
      noGroups: "No tienes grupos registrados en Join. Crea un grupo en Join e intenta nuevamente.",
      sendReplyTo: "¿Estás seguro de enviar la respuesta a este grupo?",
      sendEditReplyTo: "¿Estás seguro de enviar la edición a este grupo?",
      save: "Guardar",
      loadJSON: "Cargar JSON",
      edited: "Editado",
      sendEdit: "Enviar edición",
      imageLoaded: "Imagen",
      actions: {
        save: "Guardar",
        clearForm: "Limpiar Formulario",
        clearSection: "Limpiar Sección",
        cancel: "Cancelar",
        newQuestion: "Nueva Pregunta",
        search: "Buscar",
        copy: "Copiar pregunta",
        delete: "Eliminar pregunta",
        uploadImage: "Subir imagen",
        deleteImage: "Eliminar imagen",
        closeEdit: "Cerrar"
      },
      default: {
        untitledForm: "Formulario sin título",
        option1: "Opción 1",
      },
      confirmation: {
        deleteMandatory: "También eliminar campos obligatorios. (solo editables)",
        section: {
          title: "Limpiar Sección",
          description: "¿Estás seguro de limpiar la sección actual? Los datos ingresados no podrán recuperarse.",
          action: "Limpiar Sección"
        },
        form: {
          title: "Limpiar Formulario",
          description: "¿Estás seguro de limpiar todo el formulario? Los datos ingresados no podrán recuperarse.",
          action: "Limpiar Formulario"
        },
      },
      questions: {
        shortAnswer: "Respuesta corta",
        paragraph: "Párrafo",
        multipleChoice: "Respuesta única",
        checkboxes: "Respuesta múltiple",
        dropdown: "Seleccionador",
        linearScale: "Escala lineal",
        date: "Selector de fechas",
        time: "Selector de horas",
        section: "Sección",
      },
      fields: {
        title: "Título",
        description: "Descripción",
        question: "Pregunta",
        shortAnswerText: "Texto respuesta corta",
        longAnswerText: "Texto respuesta larga",
        optionText: "Texto de la opción",
        addOption: "Agregar opción",
        from: "Desde",
        to: "Hasta",
        labelFrom: "Etiqueta desde",
        labelTo: "Etiqueta hasta",
        date: "Fecha",
        time: "Hora",
        required: "Obligatorio",
        organizations: "Organizaciones",
        photo: "Imagen de formulario",
        section: "Sección",
        validations: "Validaciones",
        score: "Formulario con Puntajes",
        scoreRuleStatus: "Reglas",
        scoreLabel: "Puntaje",
        editable: "Editable",
        image: "Imagen"
      },
      preview: {
        selectGroup: "Seleccionar Grupo",
        yourAnswer: "Respuesta",
        chooseOption: "Elige una opción",
        pickDate: "Elige una fecha",
        pickTime: "Elige una hora",
        submit: "Enviar",
        edit: "Editar",
        clearForm: "Limpiar Formulario",
        totalScore: "Puntaje Total"
      },
      reply: {
        editUrl: "Editar respuesta"
      },
      scoreRules: {
        headers: {
          value: "Valor",
          operator: "Operador",
          title: 'Título',
          description: "Descripción",
        },
        actions: {
          addRule: "Agregar otra regla"
        }
      },
      validations: {
        default: "Esta pregunta es obligatoria.",
        required: "Este campo es obligatorio.",
        email: "Debe ingresar un correo electrónico válido.",
        phone: "Debe ingresar un número de teléfono válido.",
        rut: "Debe ingresar un rut válido.",
        scoreValidNumber: "El puntaje debe estar entre 0 y 9",
        fileSizeError: "El archivo debe ser a lo más 5Mb.",
        fileUnsupportedFile: "El tipo de archivo ingresado no es soportado.",
        noTenantsSelected: "Tienes que elegir al menos una organización para este formulario.",
        options: {
          email: "Correo electrónico",
          phone: "Teléfono",
          rut: "Rut",
          regex: "Expresión regular",
        },
      }
    }
  },
}
